module.exports = __webpack_public_path__ + "img/roll_back.f3579c94.svg";